import {AltAccoStars} from '../AltAccoStars/AltAccoStars';
import {ReactNode} from 'react';
import {useSelector} from 'react-redux';
import {isInternationalSelector} from '@stencil/hotels-common-reducer/src/selectors';

//Icons
import HappyRatingStarIcon from '@stencil/icons/src/HappyRatingStarIcon/HappyRatingStarIcon';

//Styles
import * as S from './AltAccoRatingsRenderer.styles';

interface AltAccoStarsAdditionalParams {
  defaultComponent: (index: number) => ReactNode;
  isMweb?: boolean;
  isMwebSrp?: boolean;
  isCarousel?: boolean;
}

interface AltAccoRatingsRendererProps {
  hotelStarRating: number;
  isAltAcco: boolean;
  additionalParams: AltAccoStarsAdditionalParams;
  propertyLabel?: string;
  isSrpV2?: boolean;
}

export const AltAccoRatingsRenderer: React.FC<AltAccoRatingsRendererProps> = props => {
  const {hotelStarRating, isAltAcco, additionalParams, propertyLabel = '', isSrpV2} = props;
  const {defaultComponent, isMweb, isMwebSrp, isCarousel} = additionalParams;

  const isInternational = useSelector(isInternationalSelector);

  if (hotelStarRating && isAltAcco && !isInternational) {
    return (
      <AltAccoStars
        hotelRating={hotelStarRating}
        isMweb={isMweb}
        isMwebSrp={isMwebSrp}
        isCarousel={isCarousel}
      />
    );
  }

  if (isSrpV2) {
    if (hotelStarRating || propertyLabel) {
      return (
        <S.HotelTag>
          {!!hotelStarRating && !isAltAcco && (
            <S.HotelStarRating>
              <span>{hotelStarRating}</span>
              <HappyRatingStarIcon width="1rem" height="1rem" margin="0 0.2rem 0 0" />
            </S.HotelStarRating>
          )}
          <S.PropertyLabel $isHotelStarRating={!!hotelStarRating}>{propertyLabel}</S.PropertyLabel>
        </S.HotelTag>
      );
    }
  } else if (hotelStarRating) {
    return <>{[...Array(hotelStarRating)].map((_, i) => defaultComponent(i))}</>;
  }

  return null;
};
